import { styled } from "styled-components";
import Button from "./Button";
import StatButton from "./StatButton";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  @media (max-width: 800px) {
    display: ${(props) => (props.tab === "stats" ? `flex` : `none`)};
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex: 1;
`;

const CharacterStats = ({ character, rollDie, currentTab }) => {
  return (
    <Wrapper tab={currentTab}>
      <Button onClick={() => rollDie("", 0)}>Roll a d20</Button>
      <Row>
        <StatButton
          onClick={() => rollDie("might", character.bonuses.might)}
          label={"might"}
          value={character.bonuses.might}
        />
        <StatButton
          onClick={() => rollDie("speed", character.bonuses.speed)}
          label={"speed"}
          value={character.bonuses.speed}
        />
      </Row>
      <Row>
        <StatButton
          onClick={() => rollDie("mind", character.bonuses.mind)}
          label={"mind"}
          value={character.bonuses.mind}
        />
        <StatButton
          onClick={() => rollDie("defense", 0)}
          label={"defense"}
          value={character.bonuses.defense}
        />
      </Row>
    </Wrapper>
  );
};

export default CharacterStats;
